import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnInit,
  Renderer2,
  inject,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep, map } from 'lodash-es';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Table } from 'primeng/table';
import { forkJoin, Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { ApiConstants } from 'src/app/base/api-constants';
import { GlobalConstants } from 'src/app/base/global.constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { DMConstants } from 'src/app/pages/designs/data-model/data-model.component';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { UtilService } from 'src/app/services/util.service';
import { getForeignKey, setForeignKey } from 'src/app/STORE/actions/datamodel.actions';
import { setTablesForQuery, getTablesForQuery, getPageVariables } from 'src/app/STORE/actions/screens.actions';
import { metaInfo } from 'src/app/STORE/selectors/applifecycle.selector';
import { foreignKeyTbl } from 'src/app/STORE/selectors/datamodel.selector';
import { picklist } from 'src/app/STORE/selectors/propertypane.selector';

import { queryTables, selectedScreen, setPageVariables } from 'src/app/STORE/selectors/screens.selector';

export enum lookupTypes {
  FK_INDEX = 'Foreignkey Index',
  QUERY_VIEW = 'Query View'
}
@AutoUnsubscribe({ arrayName: 'subscriptions' })
@Component({
  selector: 'vb-pg-lookup-configuration',
  templateUrl: './pg-lookup-configuration.component.html',
  styleUrls: ['./pg-lookup-configuration.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PgLookupConfigurationComponent),
      multi: true
    }
  ],
  standalone: false //NOSONAR
})
export class PgLookupConfigurationComponent implements OnInit, OnDestroy, ControlValueAccessor {
  private confirmationDialogService = inject(ConfirmationDialogService);
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private store = inject(Store);
  private baseService = inject(HttpBaseService);
  private util = inject(UtilService);
  private translateService = inject(TranslateService);
  private appGlobalService = inject(AppGlobalService);
  private translate = inject(TranslateService);
  private cd = inject(ChangeDetectorRef);

  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  private refAppId: any = null;
  @Input() element: any;
  @Input() formData: any;
  @Input() disableField = false;
  @Input() currentScreen: any;
  @Input() currentNode: any = null;
  @Input() currNodeType: any = null;
  @Input() searchTerm = null;
  lookupType = GlobalConstants.lookupType;
  lookupDisplayType = GlobalConstants.lookupDisplayType;
  lookupToForeignkey = null;
  mandatoryFiltersSid = null;
  optionalFiltersSid = null;
  lookupToQueryView: any = null;
  lookupDefinition = null;
  executeOnEvent: string[] = [];
  selectedFormFieldsFieldChange: string[] = [];
  selectedFormFieldsVariableChange: string[] = [];
  autoFillIfOneResult = null;
  noLongerFields: string = '';
  OutputMappingFieldsWarning: string = '';
  fieldMismatchWarning: string = '';
  leftFields: string = '';
  rightFields: string = '';
  displayFields: any = null;
  displayFieldOps: any = [];
  allFieldsFiltered: any[] = [];
  activePopupIndex: number | null = null;
  popupType: 'warning' | 'error' | null = null;
  activePopupSection: string | null = null;
  lookupTypes: any = [];
  executeOnEvents: any = [
    //   {
    //   label: 'On Form Load',
    //   value: 'OnFormLoad'
    //  },
    {
      label: 'On Field Change',
      value: 'OnchangeofSelectedFormFields'
    },
    {
      label: 'On Page Variables Change',
      value: 'OnchangeofPageVariables'
    }
  ];
  displayTypes: any = [
    {
      label: 'Dropdown',
      value: 'Dropdown'
    }
  ];
  foreignKeys: any = [];
  lookupDefs: any = [];
  allFields: any = [];
  allFieldsMap: any[] = [];
  ptAllFields: any = [];
  inputMapping: any[] = [];
  outputMapping: any[] = [];
  subscriptions: Subscription[] = [];
  isLoading = false;
  backupVal: any = null;
  fieldMap: any = [];
  inputFilters = [];
  outputFilters = [];
  listfields: any = [];
  lastFetchedTableId = ''; // Track which table we last fetched fields for
  initialLoad = true;
  appId = '';
  hideOutMap = false;
  lookupBckValues: any;
  lookupPrps = [
    {
      name: 'lookupType',
      label: this.translateService.instant('LOOKUP_TYPE'),
      info: this.translateService.instant('LK_TYPE_INFO'),
      lblWidth: 'col-sm-6'
    },
    {
      name: 'lookupDisplayType',
      label: this.translateService.instant('LOOKUP_DISPLAY_TYPE'),
      info: this.translateService.instant('LK_DIS_TYP_INFO'),
      lblWidth: 'col-sm-6'
    },
    {
      name: 'lookupToForeignkey',
      label: this.translateService.instant('LOOKUP_TO_FK'),
      info: this.translateService.instant('LK_TO_FK_INFO'),
      lblWidth: 'col-sm-6'
    },
    {
      name: 'lookupToQueryView',
      label: this.translateService.instant('LOOKUP_TO_QV'),
      info: this.translateService.instant('LK_TO_QV_INFO'),
      lblWidth: 'col-sm-6'
    },
    {
      name: 'lookupDefinition',
      label: this.translateService.instant('LOOKUP_DEF'),
      info: this.translateService.instant('LK_DEF_INFO'),
      lblWidth: 'col-sm-6'
    },
    {
      name: 'executeOnEvent',
      label: 'Execute on Events',
      info: this.translateService.instant('LK_EXECUTE_ON_EVENT_INFO'),
      lblWidth: 'col-sm-6'
    },
    {
      name: 'selectedFormFieldsFieldChange',
      label: 'Specify fields for OnFieldChange Event',
      info: 'Specify Form Fields to observe for modifications',
      lblWidth: 'col-sm-6'
    },
    {
      name: 'selectedFormFieldsVariableChange',
      label: 'Specify fields for OnPageVariableChange Event',
      info: 'Specify Page Variables to observe for modifications',
      lblWidth: 'col-sm-6'
    },
    {
      name: 'displayFields',
      label: this.translateService.instant('DIS_FLD'),
      info: this.translateService.instant('LK_DIS_MAP_INFO'),
      lblWidth: this.lookupType === lookupTypes.QUERY_VIEW ? 'col-sm-6' : 'col-sm-12'
    },
    {
      name: 'inputMapping',
      label: this.translateService.instant('INPMAP'),
      info: this.translateService.instant('LK_INP_MAP_INFO'),
      lblWidth: 'col-sm-12'
    },
    {
      name: 'outputMapping',
      label: this.translateService.instant('OUTMAP'),
      info: this.translateService.instant('LK_OUT_MAP_INFO'),
      lblWidth: 'col-sm-12'
    }
  ];
  queryTbls: any = [];
  tblProps: any = null;
  isForeignKey = false;
  pageVariables = [];
  metaInfo: any;
  formFields: any[] = [];
  parentForeignKeys: any[];
  referredTblGroupFields: any[] = [];
  orgId: any;
  listtableId: any = null;
  lookupInitialized = false;

  get model() {
    return this.modelValue;
  }

  toggleErrorPopup(index: number, type: 'warning' | 'error', section: string = '') {
    if (this.activePopupIndex === index && this.popupType === type && this.activePopupSection === section) {
      this.closePopup();
    } else {
      this.activePopupIndex = index;
      this.popupType = type;
      this.activePopupSection = section;
    }
  }

  closePopup() {
    this.activePopupIndex = null;
    this.popupType = null;
    this.activePopupSection = null;
  }

  writeValue(value: any): void {
    this.modelValue = value;
    if (value) {
      this.backupVal = value;
      this.lookupType = value?.lookupType ? value.lookupType : lookupTypes.FK_INDEX;
      this.lookupToForeignkey = value?.lookupToForeignkey;
      this.lookupDefinition = value?.lookupDefinition;
      // if(value?.executeOn?.formLoad && !this.executeOnEvent.includes('OnFormLoad')) {
      //   this.executeOnEvent.push('OnFormLoad');
      // }
      if (value?.executeOn?.fieldChange && !this.executeOnEvent.includes('OnchangeofSelectedFormFields')) {
        this.executeOnEvent.push('OnchangeofSelectedFormFields');
      }
      if (value?.executeOn?.variableChange && !this.executeOnEvent.includes('OnchangeofPageVariables')) {
        this.executeOnEvent.push('OnchangeofPageVariables');
      }
      this.selectedFormFieldsFieldChange = value?.executeOn?.fieldChanges || [];
      this.selectedFormFieldsVariableChange = value?.executeOn?.variableChanges || [];
      this.lookupToQueryView = value?.lookupToQueryView;
      this.displayFields = value?.displayMapping ? value.displayMapping : value?.displayFields;
      this.autoFillIfOneResult = value?.autoFillIfOneResult;
      this.lookupBckValues = cloneDeep(value);
      this.hideShowOutputMap();
      if (this.lookupType === lookupTypes.FK_INDEX) {
        // Populate lookupTypes array immediately so dropdown shows FK option
        this.lookupTypes = [{ label: lookupTypes.FK_INDEX, value: lookupTypes.FK_INDEX }];
        this.formOptions();
      }
      // Fetch query tables to check if Query View option should be available
      this.getQueryTbls();
    } else if (this.isForeignKey) {
      this.lookupType = lookupTypes.FK_INDEX;
      // Populate lookupTypes for FK case
      this.lookupTypes = [{ label: lookupTypes.FK_INDEX, value: lookupTypes.FK_INDEX }];
    } else {
      this.lookupType = lookupTypes.QUERY_VIEW;
      this.getQueryTbls();
    }
    this.setDisplayFldWid();
  }

  handleClear() {
    this.executeOnEvent = [];
    this.set();
  }

  handleMultiselectValueClear() {
    const changeofSelectedFormFields = this.executeOnEvent.includes('OnchangeofSelectedFormFields');

    if (!changeofSelectedFormFields) {
      this.selectedFormFieldsFieldChange = [];
    }

    const changeofSelectedFormFieldsVariable = this.executeOnEvent.includes('OnchangeofPageVariables');
    if (!changeofSelectedFormFieldsVariable) {
      this.selectedFormFieldsVariableChange = [];
    }
  }

  set() {
    this.handleMultiselectValueClear();
    let lkconfig = {
      lookupType: this.lookupType,
      lookupDisplayType: this.lookupDisplayType
    };
    switch (this.lookupType) {
      case lookupTypes.FK_INDEX: {
        const fk = this.foreignKeys?.find((d) => d.sid === this.lookupToForeignkey);
        // Extract field id: if currentNode contains '_', take the 2nd part, else take the whole
        const fieldId = String(this.currentNode).includes('_')
          ? String(this.currentNode).split('_')[1]
          : String(this.currentNode);
        const pf = this.ptAllFields.find((f) => f.sid === fk?.mappings.find((m) => m.child === fieldId)?.parent);

        // Get appId from lookupDefinition or fallback to foreignKey
        const lookupDef = this.lookupDefs?.find((d) => d.sid === this.lookupDefinition);
        const appId = lookupDef?.appId || fk?.appId || this.appId;

        lkconfig = {
          ...lkconfig,
          ...{
            lookupToForeignkey: this.lookupToForeignkey,
            lookupDefinition: this.lookupDefinition,
            executeOn: {
              formLoad: this.executeOnEvent?.includes('OnFormLoad'),
              fieldChange: this.executeOnEvent?.includes('OnchangeofSelectedFormFields'),
              variableChange: this.executeOnEvent?.includes('OnchangeofPageVariables'),
              fieldChanges: this.selectedFormFieldsFieldChange || [],
              variableChanges: this.selectedFormFieldsVariableChange || []
            },
            outputMapping: !this.hideOutMap
              ? JSON.parse(JSON.stringify(this.outputMapping?.filter((d) => d?.lookupField && d?.tableField)))
              : undefined,
            tableId: fk?.parentTableSid,
            appId: appId === this.appId ? null : appId
          }
        };
        this.setDisplayFldWid();
        break;
      }
      case lookupTypes.QUERY_VIEW: {
        // Get appId from lookupDefinition or fallback to query view table
        const lookupDef = this.lookupDefs?.find((d) => d.sid === this.lookupDefinition);
        const qvTable = this.queryTbls?.find((t) => t.tableId === this.lookupToQueryView);
        const appId = lookupDef?.appId || qvTable?.appId || this.tblProps?.appId || this.appId;

        lkconfig = {
          ...lkconfig,
          ...{
            lookupToQueryView: this.lookupToQueryView,
            lookupDefinition: this.lookupDefinition,
            executeOn: {
              formLoad: this.executeOnEvent?.includes('OnFormLoad'),
              fieldChange: this.executeOnEvent?.includes('OnchangeofSelectedFormFields'),
              variableChange: this.executeOnEvent?.includes('OnchangeofPageVariables'),
              fieldChanges: this.selectedFormFieldsFieldChange || [],
              variableChanges: this.selectedFormFieldsVariableChange || []
            },
            inputMapping: this.inputMapping
              ?.filter((d) => d?.lookupField && d?.tableField)
              ?.map((item) => {
                const tblFld = this.allFields.find((f) => item?.tableField && f.sid == item?.tableField?.sid);
                return {
                  ...item,
                  lookupField: Object.fromEntries(
                    Object.entries(item?.lookupField).filter(([key]) => key !== 'f_type' && key !== 'name')
                  ),
                  tableField: {
                    ...Object.fromEntries(
                      Object.entries(item?.tableField).filter(([key]) => key !== 'f_type' && key !== 'name')
                    ),
                    ...{
                      fkTableSid: tblFld?.fkTableSid,
                      fkId: tblFld?.fkId
                    }
                  },
                  // Add fkAppId if fkTableSid exists
                  ...(tblFld?.fkTableSid ? { tableField: { ...item.tableField, fkAppId: tblFld?.aid } } : {})
                };
              }),
            outputMapping: !this.hideOutMap
              ? this.outputMapping
                  ?.filter((d) => d?.lookupField && d?.tableField)
                  ?.map((item) => {
                    const tblFld = this.allFields.find((f) => item?.tableField && f.sid == item?.tableField?.sid);
                    return {
                      ...item,
                      lookupField: Object.fromEntries(
                        Object.entries(item?.lookupField).filter(([key]) => key !== 'f_type' && key !== 'name')
                      ),
                      tableField: {
                        ...Object.fromEntries(
                          Object.entries(item?.tableField).filter(([key]) => key !== 'f_type' && key !== 'name')
                        ),
                        ...{
                          fkTableSid: tblFld?.fkTableSid,
                          fkId: tblFld?.fkId
                        }
                      },
                      // Add fkAppId if fkTableSid exists
                      ...(tblFld?.fkTableSid ? { tableField: { ...item.tableField, fkAppId: tblFld?.aid } } : {})
                    };
                  })
              : undefined,
            tableId: this.lookupToQueryView,
            appId: appId === this.appId ? null : appId
          }
        };
        break;
      }
      default: {
        break;
      }
    }
    this.backupVal = lkconfig;
    this.onChange?.(lkconfig);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    // this.disabled = isDisabled;
  }

  addToSubscriptionsList(subName) {
    this.subscriptions.push(subName);
  }

  clearLookup() {
    this.lookupDefinition = null;
    this.displayFields = null;
    this.inputMapping = [];
    this.outputMapping = [];
    this.inputFilters = [];
    this.outputFilters = [];
    this.executeOnEvent = [];
    this.selectedFormFieldsFieldChange = [];
    this.selectedFormFieldsVariableChange = [];
    this.set();
  }

  setDisplayFldWid() {
    const lkPrps = cloneDeep(this.lookupPrps);
    this.lookupPrps = lkPrps.map((prp) => {
      if (prp.name === 'displayFields') {
        if (this.lookupType === lookupTypes.FK_INDEX) {
          prp = { ...prp, ...{ lblWidth: 'col-sm-12' } };
        } else if (this.lookupType === lookupTypes.QUERY_VIEW) {
          prp = { ...prp, ...{ lblWidth: 'col-sm-6' } };
        }
      }
      return prp;
    });
  }

  changeLkType(event) {
    this.lookupInitialized = false;
    this.hideShowOutputMap();
    if (this.lookupType === lookupTypes.FK_INDEX) {
      this.lookupToQueryView = null;
      this.changeFk(null);
    } else if (this.lookupType === lookupTypes.QUERY_VIEW) {
      this.lookupToForeignkey = null;
      this.clearLookup();
      this.ptAllFields = [];
      this.getQueryTbls();
      this.fetchReferredTableFields();
    }
    this.setDisplayFldWid();
  }

  hideShowOutputMap() {
    if (
      (this.currNodeType?.toLowerCase() === 'filterfield' || this.currNodeType?.toLowerCase() === 'searchfield') &&
      this.lookupType === lookupTypes.FK_INDEX
    ) {
      this.hideOutMap = true;
    } else if (
      (this.currNodeType?.toLowerCase() === 'filterfield' || this.currNodeType?.toLowerCase() === 'searchfield') &&
      this.lookupType === lookupTypes.QUERY_VIEW
    ) {
      this.hideOutMap = false;
    }
  }

  getQueryTbls() {
    this.isLoading = true;
    this.store.dispatch(setTablesForQuery({ queryTables: null }));
    this.store.dispatch(getTablesForQuery({ queryTblsApiConstants: ApiConstants.getAllTables }));
    const queryViewSub = this.store.select(queryTables).subscribe((data: any) => {
      if (data) {
        this.isLoading = false;
        this.queryTbls = data
          .filter((d) => d.tableType === DMConstants.QUERY_VIEW && this.currentScreen?.tableId !== d.tableId)
          .sort((a, b) => a.tableName.localeCompare(b.tableName));
        if (this.lookupToQueryView && this.queryTbls.length) {
          this.changeQueryTbl(null);
        }
        // Update lookupTypes based on query view availability
        this.updateLookupTypesBasedOnQueryViews();
        if (queryViewSub) {
          queryViewSub.unsubscribe();
        }
      }
    });
    this.addToSubscriptionsList(queryViewSub);
  }

  updateLookupTypesBasedOnQueryViews() {
    const hasQueryViewTables = this.queryTbls?.length > 0;
    if (this.isForeignKey) {
      // If there are foreign keys, start with FK_INDEX option
      this.lookupTypes = [
        { label: lookupTypes.FK_INDEX, value: lookupTypes.FK_INDEX }
      ];
      // Only add Query View option if query view tables exist
      if (hasQueryViewTables) {
        this.lookupTypes.push({ label: lookupTypes.QUERY_VIEW, value: lookupTypes.QUERY_VIEW });
      }
    } else if (hasQueryViewTables) {
      // If no foreign keys but query views exist, show only Query View
      this.lookupTypes = [{ label: lookupTypes.QUERY_VIEW, value: lookupTypes.QUERY_VIEW }];
    }
  }

  resetonChangeFK() {
    this.lookupInitialized = false;
    this.formOptions();
    this.clearLookup();
    this.ptAllFields = [];
    this.set();
  }

  iterateOverDetailForm(parent, flds, isQuery, fk) {
    parent?.children?.find((f) => {
      if (f?.type?.toLowerCase() === 'formfield' && flds.includes(f?.key)) {
        if (f?.data?.properties) {
          const lkconfig = f?.data?.properties?.lookupConfiguration;
          if (lkconfig?.lookupToQueryView) {
            let msg = this.translateService.instant('QUERY_WARN').replaceAll('{field}', f.title);
            msg = msg.replaceAll('{foreignkey}', fk?.fkName);
            this.util.showMessage('error', msg);
            isQuery = true;
          }
        }
      } else if (f?.children) {
        isQuery = this.iterateOverDetailForm(f, flds, isQuery, fk);
        if (isQuery) {
          return isQuery;
        }
      }
    });
    return isQuery;
  }

  changeFk(event) {
    if (event && this.lookupToForeignkey) {
      // logic to check whether composite foreign key is part of query table
      const fk = this.foreignKeys.find((f) => f.sid === this.lookupToForeignkey);
      if (fk && fk?.mappings?.length > 1) {
        // get the other composite foreign key fields
        const flds = fk?.mappings?.filter((m) => m.child !== this.currentNode)?.map((mp) => mp.child);
        let isQuery = false;
        try {
          
          const screenData = JSON.parse(this.currentScreen?.contentAttachment);
          const detailForm = this.util.findNodeByKeyValue(screenData, 'type', 'form');
          if (detailForm) {
            isQuery = this.iterateOverDetailForm(detailForm, flds, isQuery, fk);
          }
        } catch (e) {
          console.error(e);
        }
        if (!isQuery) {
          this.resetonChangeFK();
        } else {
          setTimeout(() => {
            this.lookupToForeignkey = this.backupVal?.lookupToForeignkey;
          }, 100);
        }
      } else {
        this.resetonChangeFK();
      }
    } else {
      this.resetonChangeFK();
    }
  }

  changeQueryTbl(event) {
    this.formOptionsForQuerTbl();
    this.ptAllFields = [];
    this.tblProps = null;
    if (event) {
      this.clearLookup();
      this.set();
    }
  }

  buildFld(fld: any) {
    return {
      sid: fld.sid,
      name: fld.name,
      f_type: fld.f_type,
      tableId: fld.f_tableId,
      appId: fld.appId === this.appId ? null : fld.appId
    };
  }

  changeLookup(event?) {
    if (!this.lookupDefinition) {
      this.clearLookup();
      return;
    }
    if (event) {
      this.initialLoad = false;
    } else {
      this.initialLoad = true;
    }
    const params: any = {
      lookupdefinitionId: this.lookupDefinition,
      appId: this.refAppId ? this.refAppId : this.appGlobalService.get('appId')
    };
    if (this.refAppId) {
      params['referredAppId'] = this.refAppId;
    }
    this.baseService.get(ApiConstants.getLookupDefinitionById, params).subscribe({
      next: (result: any) => {
        const lookupDef = result;
        if (lookupDef?.tableId) {
          this.listtableId = lookupDef?.tableId;
        }
        if (lookupDef && this.ptAllFields.length) {
          if (this.lookupType == lookupTypes.FK_INDEX) {
            let fk = this.foreignKeys?.find((d) => d.sid == this.lookupToForeignkey);
            this.displayFields = lookupDef?.displayField?.map((dm) => {
              let f1 = this.ptAllFields.find((f) => f.sid == dm.referenceField);
              let f2 = this.ptAllFields.find((f) => f.sid == dm.displayField);
              return {
                referenceField: {
                  sid: f1?.sid,
                  name: f1?.name,
                  f_type: f1?.f_type,
                  tableId: f1?.f_tableId,
                  appId: f1?.appId == this.appId ? null : f1.appId
                },
                displayField: {
                  sid: f2?.sid,
                  name: f2?.name,
                  f_type: f2?.f_type,
                  tableId: f2?.f_tableId,
                  appId: f2?.appId == this.appId ? null : f2?.appId
                }
              };
            });
            this.inputFilters = this.util.formMapForParFld(this.ptAllFields, lookupDef?.inputFilters);
            this.outputFilters = this.util.formMapForParFld(this.ptAllFields, lookupDef?.fields);
            this.inputMapping = lookupDef?.inputFilters?.map((df) => {
              let fld = this.ptAllFields.find((f) => f.sid == df);
              if (!fld) {
                return null;
              }
              let f2 = this.allFields.find((f) => f.sid == fk?.mappings?.find((m) => m.parent == fld.sid)?.child);
              let tableField = f2
                ? {
                    sid: f2.sid,
                    name: f2.name,
                    f_type: f2.f_type,
                    tableId: f2.f_tableId,
                    appId: f2.appId == this.appId ? null : f2.appId
                  }
                : null;
              if (this.initialLoad) {
                // form the tableField on initialization for input mapping else assign default value
                if (this.backupVal?.inputMapping) {
                  let curr = this.backupVal.inputMapping?.find((m) => m.lookupField?.sid == fld.sid);
                  if (curr) {
                    tableField = curr.tableField;
                  }
                }
              }
              return {
                lookupField: {
                  sid: fld.sid,
                  name: fld.name,
                  f_type: fld.f_type,
                  tableId: fld.f_tableId,
                  appId: fld.appId == this.appId ? null : fld.appId
                },
                tableField: tableField
              };
            })?.filter(Boolean);
            if (!this.hideOutMap) {
              this.outputMapping = lookupDef?.fields?.map((df) => {
                let fld = this.ptAllFields.find((f) => f.sid == df);
                if (!fld) {
                  return null;
                }
                let f2 = null;
                let fieldEnabled = false;
                if (this.initialLoad) {
                  // form the tableField on initialization
                  if (this.backupVal?.outputMapping) {
                    const curr = this.backupVal.outputMapping?.find((m) => m?.lookupField?.sid === fld.sid);
                    if (curr) {
                      f2 = { ...curr.tableField };
                      fieldEnabled = curr.fieldEnabled ? curr.fieldEnabled : false;
                    }
                  }
                }
                return {
                  lookupField: {
                    sid: fld.sid,
                    name: fld.name,
                    f_type: fld.f_type,
                    tableId: fld.f_tableId,
                    appId: fld.appId == this.appId ? null : fld.appId
                  },
                  tableField: f2,
                  fieldEnabled
                };
              })?.filter(Boolean);
              this.getNoLongerMessage();
            }
          } else if (this.lookupType == lookupTypes.QUERY_VIEW) {
            if (this.tblProps) {
              if (lookupDef?.displayFieldForQueryView) {
                this.displayFields = this.util.formMapForParFld(this.ptAllFields, lookupDef.displayFieldForQueryView);
              }
              if (this.tblProps?.t_mandatory_filters_sid) {
                this.mandatoryFiltersSid = this.tblProps?.t_mandatory_filters_sid;
              }
              if (this.tblProps?.t_optional_filters_sid) {
                this.optionalFiltersSid = this.tblProps?.t_optional_filters_sid;
              }
              this.inputFilters = this.util.formMapForParFld(
                this.ptAllFields,
                this.tblProps?.t_mandatory_filters?.split(',')
              );
              this.outputFilters = this.util.formMapForParFld(
                this.ptAllFields,
                this.tblProps?.t_optional_filters?.split(',')
              );
              let filters: any[] = [];
              if (this.tblProps?.t_mandatory_filters) {
                filters = [...(this.tblProps?.t_mandatory_filters?.split(',') || [])];
              }
              if (this.tblProps?.t_optional_filters) {
                filters = [...filters, ...(this.tblProps?.t_optional_filters?.split(',') || [])];
              }
              this.inputMapping = filters?.map((df) => {
                let fld = this.ptAllFields.find((f) => f.sid == df);
                let tableField = null;
                if (this.initialLoad) {
                  // form the tableField on initialization for input mapping else assign default value
                  if (this.backupVal?.inputMapping) {
                    const curr = this.backupVal.inputMapping?.find((m) => m?.lookupField?.sid == fld.sid);
                    if (curr) {
                      tableField = { ...curr.tableField, ...{ name: this.metaInfo[curr.tableField?.sid] } };
                    }
                  }
                }
                return {
                  lookupField: {
                    sid: fld.sid,
                    name: fld.name,
                    f_type: fld.f_type,
                    tableId: fld.f_tableId,
                    appId: fld.appId == this.appId ? null : fld.appId
                  },
                  tableField: tableField
                };
              });
              if (!this.hideOutMap) {
                this.outputMapping = lookupDef?.fields?.map((df) => {
                  let fld = this.ptAllFields.find((f) => f.sid == df);
                  let f2 = null;
                  let fieldEnabled = false;
                  if (this.initialLoad) {
                    // form the tableField on initialization
                    if (this.backupVal?.outputMapping) {
                      const curr = this.backupVal.outputMapping?.find((m) => m?.lookupField?.sid === fld.sid);
                      if (curr) {
                        f2 = { ...curr.tableField, ...{ name: this.metaInfo[curr.tableField?.sid] } };
                        fieldEnabled = curr.fieldEnabled ? curr.fieldEnabled : false;
                      }
                    }
                  }
                  return {
                    lookupField: {
                      sid: fld.sid,
                      name: fld.name,
                      f_type: fld.f_type,
                      tableId: fld.f_tableId,
                      appId: fld.appId == this.appId ? null : fld.appId
                    },
                    tableField: f2,
                    fieldEnabled
                  };
                });
                this.getNoLongerMessage();
              }
            }
          }
          if (this.backupVal?.outputMapping) {
            this.validateOutputMappingFields();
          }
          if (event) {
            this.set();
            this.initialLoad = false;
          } else {
            this.initialLoad = true;
          }
        } else {
          if (!this.lookupDefinition) {
            this.clearLookup();
          }
        }
      },
      error: (err) => {
        console.error(err);
      }
    });
    this.appGlobalService.write('appId', this.appId);
  }

  getNoLongerMessage() {
    if (this.noLongerFields) {
      this.noLongerFields = this.noLongerFields.slice(0, -1);
      this.OutputMappingFieldsWarning = this.translate
        .instant('NO_LONGER_FLD_OUTPUT_MAPPING')
        .replace('{fields}', this.noLongerFields);
      this.noLongerFields = '';
    }
  }

  isOutputMappingFieldNoLonger(mapping: any): boolean {
    if (mapping?.tableField) {
      if (mapping?.tableField.type === 'pageVariable') {
        return this.util.isFieldNoLonger(mapping, this.pageVariables, 'pg-lookup-output-mapping');
      } else if (mapping?.tableField?.type !== 'pageVariable') {
        return this.util.isFieldNoLonger(mapping, this.allFields, 'pg-lookup-output-mapping');
      }
    }
    return false;
  }

  isOutputMappingFieldMismatch(mapping: any): boolean {
    if (mapping?.tableField && mapping?.lookupField) {
      if (mapping?.tableField.type === 'pageVariable') {
        return this.util.isFieldMismatch(mapping, this.listfields, this.pageVariables, 'pg-lookup-output-mapping');
      } else if (mapping?.tableField?.type !== 'pageVariable') {
        return this.util.isFieldMismatch(mapping, this.listfields, this.allFields, 'pg-lookup-output-mapping');
      }
    }
    return false;
  }

  checkUnSupportedFlds(lstfld, detFld) {
    if (!GlobalConstants.paramMappDataTyp[lstfld?.f_type?.toLowerCase()]?.includes(detFld?.f_type?.toLowerCase())) {
      this.leftFields += lstfld?.name + ',';
      this.rightFields += detFld?.name + ',';
    }
  }

  private validateOutputMappingFields(): void {
    // Check cache first - avoid duplicate API call if already fetched this table
    if (this.listfields?.length > 0 && this.lastFetchedTableId === this.listtableId) {
      this.processOutputMappingValidation(this.listfields);
      return;
    }
    
    const fieldInfoParams: any = { tableId: this.listtableId };
    if (this.refAppId) {
      fieldInfoParams['referredAppId'] = this.refAppId;
    }
    this.baseService.get(ApiConstants.getFieldInfo, fieldInfoParams).subscribe({
      next: (data: any[]) => this.processOutputMappingValidation(data),
      error: (err) => console.error(err)
    });
  }

  private processOutputMappingValidation(data: any[]): void {
    this.listfields = data;
    const deletedIds = this.collectDeletedAndMismatchedFields();

    if (deletedIds.length) {
      this.isLoading = true;
      this.util.handleDeletedIds(deletedIds, false, '', true, 'lookup', () => {
        this.isLoading = false;
      });
    }

    this.showFieldMismatchWarning();
  }

  private collectDeletedAndMismatchedFields(): any[] {
    const deletedIds: any[] = [];

    this.backupVal.outputMapping.forEach((p) => {
      if (p?.tableField?.type === 'pageVariable') {
        return;
      }
      const df = this.allFields.find((f) => f.sid === p.tableField?.sid);
      const lf = this.listfields.find((f) => f.sid === p.lookupField?.sid);

      if (lf && df) {
        this.checkUnSupportedFlds(lf, df);
      }
      if (!df) {
        deletedIds.push(p.tableField?.sid);
      }
    });

    return deletedIds;
  }

  private showFieldMismatchWarning(): void {
    if (!this.leftFields || !this.rightFields) {
      return;
    }

    this.fieldMismatchWarning = this.translate
      .instant('PARAM_FLD_TYP')
      .replace('{field1}', this.leftFields.slice(0, -1))
      .replace('{field2}', this.rightFields.slice(0, -1));
    this.leftFields = '';
    this.rightFields = '';

    this.confirmationDialogService.confirm({
      message: this.fieldMismatchWarning,
      acceptLabel: this.translateService.instant('OK'),
      accept: () => { /* empty */ },
      rejectVisible: false
    });
  }

  getLookupTemp(sid, referredAppId?: any) {
    if (sid) {
      this.isLoading = true;
      const lookupDefsParams = { tableId: sid };
      const tableDataParams = { sid: sid };
      if (referredAppId) {
        lookupDefsParams['referredAppId'] = referredAppId;
        tableDataParams['referredAppId'] = referredAppId;
      }
      const lookupDefs$ = this.baseService['get'](ApiConstants.getLookupDefinitions, lookupDefsParams);
      const tableData$ = this.baseService['get'](ApiConstants.getDatamodelTableData, tableDataParams);
      const combined$ = forkJoin({
        lookupDefs: lookupDefs$,
        tableData: tableData$
      }).subscribe(
        ({ lookupDefs, tableData }) => {
          this.isLoading = false;
          if (Array.isArray(lookupDefs) && lookupDefs.length > 0) {
            try {
              if (this.lookupType == lookupTypes.QUERY_VIEW) {
                this.tblProps = tableData;
                this.lookupDefs = lookupDefs;
                setTimeout(() => {
                  this.lookupDefinition = this.lookupBckValues?.lookupDefinition;
                }, 100);
                if (!this.tblProps?.t_mandatory_filters) {
                  let tblName = this.queryTbls.find((t) => t.tableId == this.lookupToQueryView)?.tableName;
                  this.util.showMessage('info', this.translateService.instant('MAND_WARN').replace('{table}', tblName));
                }
              } else {
                const fk = this.foreignKeys?.find((d) => d.sid == this.lookupToForeignkey);
                this.lookupDefs = lookupDefs?.filter((def) => def.index == fk?.parentIndexId);
              }
              this.lookupDefs.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
              });
              // Call changeLookup() to process lookup definitions
              if (this.lookupDefinition) {
                this.changeLookup();
              }
            } catch (e) {
              console.log(e);
            }
          }
          else{
            this.lookupDefs = [];
          }
        },
        (err) => {
          this.isLoading = false;
          console.error(err);
        }
      );
      this.addToSubscriptionsList(combined$);
    }
  }

  isInputMappingFieldNoLonger(mapping: any): boolean {
    if (mapping?.tableField) {
      if (mapping?.tableField.type === 'pageVariable') {
        return this.util.isFieldNoLonger(mapping, this.pageVariables, 'pg-lookup-input-mapping');
      } else if (mapping?.tableField?.type !== 'pageVariable') {
        return this.util.isFieldNoLonger(mapping, this.allFields, 'pg-lookup-input-mapping');
      }
    }
    return false;
  }

  isInputMappingFieldMismatch(mapping: any): boolean {
    if (mapping?.tableField && mapping?.lookupField) {
      // inputMapping: LHS (lookupField) is TARGET
      if (mapping?.tableField.type === 'pageVariable') {
        return this.util.isFieldMismatch(mapping, this.listfields, this.pageVariables, 'pg-lookup-input-mapping');
      } else if (mapping?.tableField?.type !== 'pageVariable') {
        return this.util.isFieldMismatch(mapping, this.listfields, this.allFields, 'pg-lookup-input-mapping');
      }
    }
    return false;
  }

  getParentTblFlds(sid, referredAppId?: any) {
    this.isLoading = true;
    const params = { tableId: sid };
    if (referredAppId) {
      params['referredAppId'] = referredAppId;
    }
    const tblfldsInfo = this.baseService.get(ApiConstants.getFieldInfo, params).subscribe({
      next: (value: any) => {
        this.isLoading = false;
        if (value) {
          this.ptAllFields = [...value];
          // Store fields in listfields cache for output mapping validation
          // This avoids duplicate getFieldInfo API call from validateOutputMappingFields()
          this.listfields = [...value];
          // Track which table we fetched to enable caching in validateOutputMappingFields()
          this.lastFetchedTableId = sid;
          this.displayFieldOps = this.ptAllFields.map((f) => {
            return {
              sid: f.sid,
              name: f.name,
              f_type: f.f_type,
              tableId: f.f_tableId,
              appId: f.appId === this.appId ? null : f.appId
            };
          });
          this.lookupDefinition = this.lookupBckValues?.lookupDefinition;
          // Call changeLookup() after fields are ready (parallel APIs, last to finish processes data)
          if (this.lookupDefinition) {
            this.changeLookup();
          }
        }
      },
      error: (e) => {
        this.isLoading = false;
        console.log(e);
      }
    });
    this.addToSubscriptionsList(tblfldsInfo);
  }

  formOptionsForQuerTbl() {
    if (this.lookupToQueryView) {
      this.getLookupTemp(this.lookupToQueryView);
      this.getParentTblFlds(this.lookupToQueryView);
    } else {
      this.lookupDefs = [];
    }
  }

  isDisplayFieldNoLonger(mapping: any): boolean {
    if (mapping.displayField) {
      return this.util.isFieldNoLonger(mapping, this.ptAllFields, 'pg-lookup-display-field');
    }
    return false;
  }

  formOptions() {
    if (this.lookupToForeignkey) {
      const fk = this.foreignKeys?.find((d) => d.sid === this.lookupToForeignkey);
      if (fk && fk.parentTableSid) {
        this.refAppId = fk?.indexRefAppId;
        this.lookupInitialized = true;
        this.getLookupTemp(fk.parentTableSid, fk?.indexRefAppId);
        this.getParentTblFlds(fk.parentTableSid, fk?.indexRefAppId);
      }
    } else {
      this.lookupDefs = [];
    }
  }

  formOptionsForQueryView() {
    /* empty */
  }

  showFilteredOptions(mapType, lookupField, event?) {
    let flds = cloneDeep(this.allFields)?.filter((item) => item.type != 'pageVariable' && !item?.fkId);
    const type = lookupField.f_type;

    // donot allow same field to be mapped for output mapping (other FK fields are allowed)
    if (mapType === 'outputMapping') {
      flds = this.allFields.filter((f) => f.sid !== this.currentNode);
    }
    // donot allow same field for mandatory params
    if (this.tblProps?.t_mandatory_filters?.includes(lookupField?.sid)) {
      flds = flds.filter((f) => f.sid !== this.currentNode);
    }
    const filtered = flds.map((fld) => {
      return {
        sid: fld.sid,
        name: fld.name,
        f_type: fld.f_type,
        tableId: fld.f_tableId,
        appId: fld.appId == this.appId ? null : fld.appId
      };
    });
    // inputMapping: LHS (lookupField) is TARGET, RHS (tableField) is SOURCE
    // outputMapping: LHS (lookupField) is SOURCE, RHS (tableField) is TARGET
    const validTypes = mapType === 'inputMapping'
      ? this.util.getSourceTypesForTarget(type.toLowerCase(), GlobalConstants.paramMappDataTyp)
      : GlobalConstants.paramMappDataTyp[type.toLowerCase()];
    this.allFieldsFiltered = filtered.filter(
      (f) =>
        validTypes?.includes(f.f_type.toLowerCase()) &&
        f?.name?.toLowerCase()?.includes(event?.query?.toLowerCase())
    );

    const groupedFields: any = [];
    if (this.allFieldsFiltered?.length > 0) {
      groupedFields.push({
        name: this.translate.instant('TABLE_FIELDS'),
        items: this.allFieldsFiltered
      });
      this.allFieldsFiltered = groupedFields;
    }

    if (this.lookupType === lookupTypes.QUERY_VIEW) {
      // Filter Referred Table Fields
      if (this.referredTblGroupFields?.length) {
        this.referredTblGroupFields?.forEach((gf) => {
          if (gf.items?.length) {
            const items = gf.items.filter(
              (f) =>
                validTypes?.includes(f.f_type.toLowerCase()) &&
                f.name.toLowerCase().includes(event?.query?.toLowerCase())
            );
            if (items?.length) {
              groupedFields.push({
                name: gf.label,
                items: items.map((item) => {
                  return {
                    sid: item.sid,
                    name: item.name,
                    f_type: item.f_type,
                    tableId: item.f_tableId,
                    appId: item.appId == this.appId ? null : item.appId,
                    fkTableSid: item.fkTableSid,
                    fkId: item.fkId,
                    fkAppId: item.fkAppId
                  };
                })
              });
            }
          }
        });
        this.allFieldsFiltered = [...groupedFields];
      }

      // Filter page variables based on the type and search query
      let filteredPV = [];
      if (type) {
        filteredPV =
          this.pageVariables?.filter(
            (f: any) =>
              validTypes?.includes(f.f_type.toLowerCase()) &&
              f.name.toLowerCase().includes(event?.query?.toLowerCase() || '')
          ) || [];
      } else {
        filteredPV =
          this.pageVariables?.filter((f: any) => f.name.toLowerCase().includes(event?.query?.toLowerCase() || '')) ||
          [];
      }
      if (filteredPV?.length > 0) {
        let groupedFields = cloneDeep(this.allFieldsFiltered);
        const pvIndex = groupedFields?.findIndex((item) => item.name === this.translate.instant('PAGE_VARIABLES'));
        if (pvIndex !== -1) {
          groupedFields[pvIndex] = {
            name: this.translate.instant('PAGE_VARIABLES'),
            items: filteredPV
          };
        } else {
          groupedFields.push({
            name: this.translate.instant('PAGE_VARIABLES'),
            items: filteredPV
          });
        }

        if (!groupedFields?.length) {
          this.allFieldsFiltered = [];
          groupedFields = [{ items: [], name: '' }];
        }
        setTimeout(() => {
          this.allFieldsFiltered = [...groupedFields];
        }, 0);
      }
    }
  }

  fetchVariables(pageSid) {
    const data = { orgId: this.currentScreen?.orgId, appId: this.appId, pageSid: pageSid };
    if (data.orgId && data.appId && data.pageSid) {
      this.store.dispatch(getPageVariables({ getPageVariablesApiConst: ApiConstants.getPageVariables, data: data }));
    }
  }

  filterCurrentTblFields(variableName) {
    if (variableName) {
      const originalFields = cloneDeep(this[variableName]);
      const removedPVFields = originalFields.filter((item) => item.type !== 'pageVariable' && !item?.fkId);
      this[variableName] = removedPVFields;
    }
  }

  onfieldSel(event, ri, mapping) {
    const value = event?.value;
    // Uncheck fieldEnabled if sysGen field is selected
    if (this.allFieldsMap[value?.sid]?.sysGen) {
      this.outputMapping[ri] = { ...this.outputMapping[ri], fieldEnabled: false };
    }
    if (value) {
      this.set();
    }
  }

  onAllowEditChange(event, ri, mapping) {
    // Prevent saving the config, if output mapping table field is not selected
    if (mapping === 'outputMapping' && !this.outputMapping[ri]?.tableField) {
      return;
    }
    setTimeout(() => {
      this.set();
    }, 100);
  }

  onRowDelete(ri, mapping) {
    const mappng = cloneDeep(this[mapping]);
    mappng[ri].tableField = null;
    this[mapping] = [...mappng];
    this.set();
  }

  fetchReferredTableFields() {
    this.baseService[ApiConstants.getSearchableFieldsByTableId.method](ApiConstants.getSearchableFieldsByTableId, {
      tableId: this.currentScreen.tableId
    }).subscribe({
      next: (value: any) => {
        if (value) {
          const referredTableInfo = this.util.getSearchableReferredTableFields(value, this.currentScreen.tableId);
          this.referredTblGroupFields = referredTableInfo.groupedFields;
        }
      },
      error: (e) => {
        console.log(e);
      }
    });
  }

  extractFormFields() {
    this.formFields = [];
    try {
      if (this.currentScreen?.contentAttachment) {
        const screenData = JSON.parse(this.currentScreen.contentAttachment);
        this.extractFieldsRecursively(screenData);
      }
    } catch (e) {
      console.error('Error parsing screen data:', e);
    }
  }

  // Recursive method to extract form fields
  extractFieldsRecursively(elements: any[]) {
    if (!elements || !Array.isArray(elements)) return;

    elements.forEach((element) => {
      if (element?.type?.toLowerCase() === 'formfield' && element?.key && element?.title) {
        // Avoid adding the current field to prevent self-reference
        if (element.key !== this.currentNode) {
          // Use metaInfo for the label to get the latest field name (handles rename)
          const fieldName = this.metaInfo?.[element.key] || element.title;
          this.formFields.push({
            label: fieldName,
            value: element.key,
            key: element.key
          });
        }
      }

      // Recursively check children
      if (element?.children) {
        this.extractFieldsRecursively(element.children);
      }
    });
  }

  ngOnInit(): void {
    this.appId = this.appGlobalService.get('appId');
    this.orgId = this.appGlobalService.get('orgId');
    this.metaInfo = this.appGlobalService.get('appmetaInfo');
    const metaInfoSub = this.store.select(metaInfo).subscribe((appmetaInfo: any) => {
      if (appmetaInfo) {
        this.metaInfo = cloneDeep(appmetaInfo);
        // Refresh formFields when metaInfo changes (e.g., field rename)
        this.extractFormFields();
      }
    });
    this.addToSubscriptionsList(metaInfoSub);

    const tableId = { tableId: this.currentScreen?.tableId };
    const dataSub = this.store.select(picklist).subscribe((pickList) => {
      if (pickList) {
        this.allFields = [...(pickList?.fieldsWithDetails || {})];
        this.allFields.forEach((f) => {
          this.fieldMap[f.sid] = f.name;
          this.allFieldsMap[f.sid] = f;
        });
      }
    });
    this.addToSubscriptionsList(dataSub);
    this.store.dispatch(
      setForeignKey({
        foreignKeyTbl: null
      })
    );
    let fkapiConstants = ApiConstants.getForeignKey;
    let data = { tableId: this.currentScreen?.tableId, orgId: this.orgId, appId: this.appId };
    this.store.dispatch(
      getForeignKey({
        fkapiConstants,
        data
      })
    );
    this.isLoading = true;

    const foreignkeySub = this.store.select(foreignKeyTbl).subscribe((data: any) => {
      const fkdata = data;
      this.isLoading = false;
      if (fkdata?.length) {
        this.foreignKeys = [...fkdata];
        if (this.currentNode) {
          this.foreignKeys = fkdata
            ?.filter((dt) => dt.mappings.find((mp) => mp.child === this.currentNode))
            .sort((a, b) => a.fkName.localeCompare(b.fkName));

          if (this.foreignKeys?.length) {
            this.isForeignKey = true;
            // Initialization moved to writeValue() to avoid duplicate API calls
            if (!this.backupVal) {
              this.lookupType = lookupTypes.FK_INDEX;
            }
            this.hideShowOutputMap();
            // Call formOptions() if it wasn't called from writeValue() (for deferred initialization)
            if (!this.lookupInitialized && this.lookupType === lookupTypes.FK_INDEX && this.lookupToForeignkey) {
              this.formOptions();
            }
            this.lookupInitialized = false; // Reset for next usage
            // Populate lookupTypes options for FK field - fixes "No Results Found" on fresh page reload
            this.updateLookupTypesBasedOnQueryViews();
          } else {
            this.isForeignKey = false;
            this.lookupTypes = [{ label: lookupTypes.QUERY_VIEW, value: lookupTypes.QUERY_VIEW }];
          }
          this.setDisplayFldWid();
          this.hideShowOutputMap();
        }

        // get referred table fields if current node is filter or search field and lookup type is query view
        if (
          (this.currNodeType?.toLowerCase() === 'filterfield' || this.currNodeType?.toLowerCase() === 'searchfield') &&
          this.lookupType === lookupTypes.QUERY_VIEW
        ) {
          this.fetchReferredTableFields();
        }
      } else {
        // No parent FKs found - state updated, initialization in writeValue()
        this.isForeignKey = false;
      }
    });

    this.addToSubscriptionsList(foreignkeySub);
    const pageVariables$ = this.store.select(setPageVariables).subscribe((response: any) => {
      const renamedData = response?.map((item) => {
        return {
          type: 'pageVariable',
          sid: item.sid,
          name: item.name,
          f_type: GlobalConstants.pageVariableMap[item.type],
          tableId: item.tableSid,
          appId: item.appId
        };
      });
      this.pageVariables = renamedData || [];
    });
    this.addToSubscriptionsList(pageVariables$);
    this.fetchVariables(this.currentScreen?.sid);
    this.extractFormFields();
  }

  ngOnDestroy(): void {
    /* required for AutoUnsubscribe */
  }
}



